import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { ServerUrlService } from './server-url.service';
import { UserType } from '../interfaces/user';

interface Response extends Array<any> {}
declare const window: any;

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  userLoggedOut: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private user: UserType | undefined;
  decryptedData: any

  constructor(
    private http: HttpClient,
    private router: Router,
    private serverUrlService: ServerUrlService
  ) {
    if (sessionStorage.getItem('userData') && !this.user) {
      this.user = JSON.parse(sessionStorage.getItem('userData'))
    }
   }

  userLogin(email, senha, modo) {
    if (modo === 'admin') {
      return this.http.post(`${this.serverUrlService.getUrl()}/login-admin`, {
        email: email.toLowerCase(), senha
      });
    }
    return this.http.post(`${this.serverUrlService.getUrl()}/login`, {
      email: email.toLowerCase(), senha
    });
  }

  checaEmail(email) {
    return this.http.post(`${this.serverUrlService.getUrl()}/usuarios/checainfo`, { email });
  }

  checaCpf(cpf) {
    return this.http.post(`${this.serverUrlService.getUrl()}/usuarios/checainfo`, { cpf });
  }

  validaCpf(cpf) {
    return this.http.get(`${this.serverUrlService.getUrl()}/usuarios/validacpf/` +  cpf );
  }

  userCadastro(registro) {
    return this.http.post(`${this.serverUrlService.getUrl()}/usuarios`, registro);
  }

  userAtualiza(registro) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        token: registro.token,
      }),
      observe: 'response' as 'body'
    };

    return this.http.put<Response>(`${this.serverUrlService.getUrl()}/usuarios`, registro, httpOptions)
      .subscribe((response: Response[any]) => {
      if (response.status === 401) {
        window.alert('Autenticação de usuário expirada, favor logar novamente.');
        this.router.navigate(['/' + this.serverUrlService.getName() + '/client/login']);
      } else {
        const userData = response.body;
        const newToken = response.headers.get('new_token');
        if (newToken) {
          userData.token = newToken;
        }

        sessionStorage.setItem('userData', JSON.stringify(userData));
        this.user = userData
        this.router.navigate(['/' + this.serverUrlService.getName() + '/client']);
      }
    });
  }

  logOutUser() {
    this.userLoggedOut.next(true);
    this.userLoggedOut.next(false);

    const userData = {};

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(userData));
    }
  }

  recuperaSenha(email) {
    return this.http.post(`${this.serverUrlService.getUrl()}/login/recuperasenha`, email);
  }

  enviaCodigoRecuperacao(query) {
    return this.http.post(`${this.serverUrlService.getUrl()}/login/trocasenha`, query);
  }

  setUser(user: UserType): void {
    this.user = user
  }

  getUser(): UserType {
    return this.user
  }

  decryptToken(token: string) {
    return this.http.post(`${this.serverUrlService.otimusUrl}/tools/auth/token/decrypt`, { token })
  }
}
